var $e41b4357ad82da8f$exports = {};
$e41b4357ad82da8f$exports = {
    "collapse": `Recolher`,
    "expand": `Expandir`
};


export {$e41b4357ad82da8f$exports as default};
//# sourceMappingURL=pt-BR.mjs.map
